module.exports = __webpack_public_path__ + "img/feu.8126b301.png";